<template>
  <div
    v-infinite-scroll="loadMore"
    :infinite-scroll-disabled="disabled"
    :infinite-scroll-distance="distance"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'BaseInfiniteScroll',

  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    distance: {
      type: Number,
      default: 200
    }
  },

  methods: {
    loadMore() {
      this.$emit('loadMore');
    }
  }
};
</script>
